import {Media, StreamError} from "../state/types";
import {actionChannel, call, delay, fork, put, take, select, race} from "redux-saga/effects";
import {SourceAction} from "../state/source";
import {GDPR} from "../state/gdpr";
import {triton} from "./triton";
import {buffers, TakeableChannel, Task} from "redux-saga";
import {StatusAction, StatusRequiredAction} from "../state/status";
import {AppState} from "../state";
import {WaitingTime} from "../state/waitingtime";
import {ApiClient} from "../../../generated/ApiClient";
import {IsMobile} from "./utils";

export const get_media = (url: string, type?: string): Media | undefined => {

    const what = type ? ['', type] : (url || '').match(/\.([a-zA-Z0-9]+)$/);
    if (what) {
        switch (what[1]) {
            case 'ogg':
                return {src: url, 'type': 'audio/ogg'};
            case 'mp3':
                return {src: url, type: 'audio/mpeg'};
            case 'aac':
                return {src: url, 'type': "audio/aac"};
            case 'dash':
                return {src: url, 'type': "dash"};
        }
    }
}

const addUrl = (element: string, urls: Media[]) => {
    element = element.trim()
    if (element) {
        let url = get_media(element, undefined);
        if (!url || !url.type) {
            urls.push({
                src: element,
                type: 'audio/aac',

            });
            urls.push({
                src: element,
                type: 'audio/mpeg',
            })
        } else {
            urls.push(url)
        }
    }
}

// eslint-disable-next-line
export function * DetectMedia(streams?:string[]) {
    const urls = [] as Media[];
    streams?.forEach(item => {
        addUrl(item, urls);
    });
    return urls;
}

export function* LoadMedias(streams?: string) {
    const urls = [] as Media[]
    if (!streams) {
        return [];
    }

    if (streams.match(/lq$|hq$|m3u$/)) {
        let url = streams.replace(/(data\/)?playlist/, 'data/playlist');
        if (url.indexOf('.json') === -1) {
            url += ".json";
        }
        for (let i = 0; i < 2; i++) {
            const resolved: {
                timeout?: boolean,
                urls?: Media[]
            } = yield race({
                timeout: delay(2000),
                urls: call(() => fetch(url, {}).then((data) => {
                    return data.json();
                }).then((data) => {
                    data.forEach((i: string, k: number) => {
                        addUrl(i, urls);
                    })
                    return urls;
                }))
            });

            if (resolved.urls) {
                return urls;
            }
        }

        yield put<StatusRequiredAction>({
            type: "RequiredStatus",
            payload: "STOP"
        });

    } else {
        addUrl(streams, urls)
        return urls;
    }
}
// eslint-disable-next-line
export function* ProcessDash(dash: Media, uuid: string) {
    return
}

export function* ProcessMedias(streams: Media[], uuid: string) {
    const state: { gdpr: GDPR, triton: number } = yield call(triton);
    const {
        medialoadtime,
        filterplayedstream,
        filternotplayedstream

    } = (yield select((appState: AppState) => appState.waitingTime)) as WaitingTime;

    const streamsWithErrors = streams.map(item => {
        return {
            stream: item,
            lastError: 0,
            playing: false
        }
    });

    let delayTask: (Task | undefined) = undefined
    const clearDelayTask = () => {
        if (delayTask)
            delayTask.cancel();
        delayTask = undefined;
    }

    function* makeDelayTask() {
        let task = delayTask;
        if (task)
            return task;
        task = yield fork(function* () {
            yield delay(medialoadtime);
            new ApiClient().postApiStatisticsPlayer({
                frontWebStatisticsPlayerModel: {
                    uuid,
                    isMobile: IsMobile(),
                    state: "player_streams_error",
                }
            }, {
                credentials: "omit"
            });
            yield put<StreamError>({
                type: "StreamError"
            });
        });
        return task;
    }

    const channel: TakeableChannel<StreamError | StatusAction> = yield actionChannel(['StreamError', "Status"], buffers.sliding(5));
    while (true) {
        clearDelayTask();
        // chyba nesmi u streamu nastat aspon 3 minuty
        const currentStream = streamsWithErrors.find(item => {
            if (item.playing) {
                return (item.lastError + filterplayedstream) < new Date().getTime() // uz hral, tedy staci jen 30 sekund prodlevy
            }
            else {
                return (item.lastError + filternotplayedstream) < new Date().getTime() //  staci jen 2 minuty prodlevy
            }
        });
        if (!currentStream)
            return;
        currentStream.playing = false;
        let stream = currentStream.stream;
        if (state.triton) {
            let ending = 'gdpr=0';
            if (state.gdpr && state.gdpr.gdprApplies) {
                ending = `gdpr=1&gdpr_consent=${state.gdpr.tcString}`;
            }
            stream = {...stream, src: `${stream.src}${stream.src.indexOf('?') > -1 ? '&' : '?'}${ending}`};
        }
        // davam 30 sekund na to, aby zacal hrat stream
        delayTask = yield fork(makeDelayTask);

        yield put<SourceAction>({
            type: "Source",
            payload: {
                type: "Audio",
                content: stream
            }
        });

        while (true) {
            const action: StreamError | StatusAction = yield take<StreamError | StatusAction>(channel);
            if (action.type === "Status") {
                if (action.payload === "PLAYING") {
                    currentStream.playing = true;
                    clearDelayTask();
                } else if (action.payload === "LOADING") {
                    delayTask = yield fork(makeDelayTask);
                } else if (action.payload === "STOPPED") {
                    clearDelayTask();
                    new ApiClient().postApiStatisticsPlayer({
                        frontWebStatisticsPlayerModel: {
                            uuid,
                            isMobile: IsMobile(),
                            state: "player_stopped",
                        }
                    }, {
                        credentials: "omit"
                    });
                    return;
                }
            } else if (action.type === "StreamError") {
                clearDelayTask();
                currentStream.lastError = new Date().getTime();
                break;
            }
        }
    }
}